// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"5b7270b5","813":"753dc6a4"}[chunkId] + ".chunk.css";
};